var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_76)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 49.8334V69.6667M70 69.6667H66.5M70 69.6667H73.5",
    stroke: "#6E4B23",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 59.1667L77.5833 53.3334L74.6666 59.1667",
    stroke: "#6E4B23",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3333 59.1667L62.4167 53.3334L59.5 59.1667",
    stroke: "#6E4B23",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6666 53.3334H61.8895C63.3636 53.3334 64.7937 52.7162 65.9447 51.5834C68.3155 49.25 71.6844 49.25 74.0552 51.5834C75.2062 52.7162 76.6363 53.3334 78.1104 53.3334H79.3333",
    stroke: "#6E4B23",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5833 63.8333C79.1638 63.8333 80.5401 62.8606 81.2552 61.424C81.641 60.6485 81.834 60.2608 81.4817 59.7138C81.1295 59.1666 80.5467 59.1666 79.3808 59.1666H75.7858C74.62 59.1666 74.0371 59.1666 73.6849 59.7138C73.3327 60.2608 73.5257 60.6485 73.9115 61.424C74.6265 62.8606 76.0028 63.8333 77.5833 63.8333Z",
    stroke: "#6E4B23",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4167 63.8333C63.9972 63.8333 65.3735 62.8606 66.0885 61.424C66.4744 60.6485 66.6673 60.2608 66.3151 59.7138C65.9629 59.1666 65.38 59.1666 64.2143 59.1666H60.6192C59.4534 59.1666 58.8705 59.1666 58.5183 59.7138C58.1661 60.2608 58.359 60.6485 58.7449 61.424C59.4599 62.8606 60.8362 63.8333 62.4167 63.8333Z",
    stroke: "#6E4B23",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75 48.0834C71.75 49.0499 70.9665 49.8334 70 49.8334C69.0335 49.8334 68.25 49.0499 68.25 48.0834C68.25 47.1169 69.0335 46.3334 70 46.3334C70.9665 46.3334 71.75 47.1169 71.75 48.0834Z",
    stroke: "#6E4B23",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_76",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_76",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSystem);
export default __webpack_public_path__ + "static/media/upload-system.1db34996419d4f7e2b2565ddaa31dad4.svg";
export { ForwardRef as ReactComponent };